<template>

<app-content>

	<app-content-head title="Update Card" back="Membership.Payments" subtitle="Update your card details for subscription payments.">

		<app-content-head-actions-item text="Confirm" :disabled="is.loading" icon="tick" :loading="is.saving" v-on:click="onSaveClick" />

	</app-content-head>

	<app-content-body :loading="is.loading" :readonly="is.saving">

        <app-content-box>

            <stripe-element-card ref="stripe" :pk="pk" v-on:token="onSuccess" v-on:error="onError" v-on:element-ready="onReady" />

        </app-content-box>

	</app-content-body>

</app-content>

</template>

<script>

import { StripeElementCard } from '@vue-stripe/vue-stripe'

export default {

	components: {
        StripeElementCard
	},

	data: function() {

		return {
            is: {
                loading: true,
                saving: false
            },
			pk: process.env.VUE_APP_STRIPE
		}

	},

	methods: {

        onSaveClick: function() {

            this.is.saving = true
		
			this.$refs.stripe.submit()
		
		},

        onReady: function() {

            this.is.loading = false
        
        },

        onError: function() {
        
            this.is.saving = false

            this.$notify({
                type: 'error',
                message: 'Card update failed, please try again.'
            })

        },

        onSuccess: function(token) {

            this.$api.post('membership/payments/update', {
                token: token.id
            }).then(function() {

                this.$router.push({
                    name: 'Membership.Payments'
                })

                this.$notify({
                    message: 'Card updated successfully.'
                })
            
            }.bind(this), function() {

                this.$notify({
                    type: 'error',
                    message: 'Card update failed, please try again.'
                })
            
            }.bind(this))
        
        }
	
	}

}

</script>

<style>

#stripe-element-errors:not(:empty) {
    color: red;
    padding: 20px;
	background-color: #c55b5b;
    border-radius: 4px;
    margin-top: 10px;
    color: #fff;
    font-weight: 400;
    font-size: 16px;
}

</style>